import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import events from "modules/events";

const LoadMore = ({
  getMoreEvents,
  postMoreEvents,
  pages,
  str,
  eventId,
  loadMoreResults
}) => {
  const getDataFromServer = () => {
    loadMoreResults();
    // if (!str) {
    //   getMoreEvents(eventId, `${+pages + 1}`);
    // } else {
    //   let obj = Object.keys(str).map(key => {
    //     if (key === "page") {
    //       return Object.defineProperty(str, "page", { value: pages + 1 });
    //     } else {
    //       return str;
    //     }
    //   });
    //   postMoreEvents(eventId, obj[0]);
    // }
  };

  return (
    <div onClick={() => getDataFromServer()} style={{ cursor: "pointer" }}>
      <svg
        width="18"
        height="19"
        viewBox="0 0 18 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 9.5C18 10.3249 17.874 11.119 17.6523 11.875H15.9333C16.2074 11.1308 16.3636 10.3336 16.3636 9.5C16.3636 5.57175 13.0606 2.375 9 2.375C7.60418 2.375 6.30327 2.75817 5.19136 3.41525L6.71155 5.54167H0.989182L2.74991 0L4.26273 2.11613C5.64055 1.28567 7.25645 0.791667 9 0.791667C13.9696 0.791667 18 4.69063 18 9.5ZM12.8013 15.5895C11.691 16.2434 10.3925 16.625 9 16.625C4.94018 16.625 1.63636 13.4283 1.63636 9.5C1.63636 8.66638 1.79264 7.86917 2.06591 7.125H0.347727C0.126 7.88104 0 8.67508 0 9.5C0 14.3094 4.02955 18.2083 9 18.2083C10.7403 18.2083 12.3537 17.7167 13.7291 16.8886L15.2452 19L17.0059 13.467H11.2835L12.8013 15.5895Z"
          fill="#2B2B2B"
        />
      </svg>
      <p>Показать ещё</p>
    </div>
  );
};

const mapStateToProps = state => ({
  pages: state.events.pages,
  str: state.events.str
});

const mapDispatchToProps = dispatch => ({
  getMoreEvents: bindActionCreators(events.actions.getMoreEvents, dispatch),
  postMoreEvents: bindActionCreators(events.actions.postMoreEvents, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LoadMore);



// WEBPACK FOOTER //
// ./src/components/Events/LoadMore.js